import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import { FamilyFilter } from '@/api/DTO/family/family.interface';

export default function FieldCommonSummaryPageFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<FamilyFilter>();

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={12}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
		</Grid>
	);
}
